/* =====================================================================
   assets/header.js — Header behaviors
   - Slide-from-right side panel (mobile nav)
   - Sticky main header on scroll
   Loaded once in layout/theme.liquid with `defer`.
   ===================================================================== */

(function () {
  if (window.__tikolishHeaderInit) return;
  window.__tikolishHeaderInit = true;

  /* ---------- Slide-from-right side panel ---------- */
  (function initPanel() {
    var overlay = document.querySelector('[data-panel-overlay]');
    var panel   = document.querySelector('[data-panel]');
    var openers = document.querySelectorAll('[data-toggle="mobile-nav"]');
    var closer  = document.querySelector('[data-panel-close]');
    if (!overlay || !panel) return;

    function openPanel() {
      overlay.classList.remove('opacity-0', 'pointer-events-none');
      overlay.setAttribute('aria-hidden', 'false');
      panel.classList.remove('translate-x-full');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePanel() {
      overlay.classList.add('opacity-0', 'pointer-events-none');
      overlay.setAttribute('aria-hidden', 'true');
      panel.classList.add('translate-x-full');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', openPanel);
    });
    if (closer) closer.addEventListener('click', closePanel);
    overlay.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
  })();

  /* ---------- Sticky main header on scroll ---------- */
  (function initSticky() {
    var headerMain = document.querySelector('[data-header-main]');
    if (!headerMain) return;

    var marker = document.createElement('div');
    marker.setAttribute('data-header-marker', '');
    headerMain.parentNode.insertBefore(marker, headerMain);

    function check() {
      var rect = marker.getBoundingClientRect();
      var isStuck = headerMain.classList.contains('is-stuck');

      if (rect.top < 0 && !isStuck) {
        document.body.style.setProperty('--stuck-header-height', headerMain.offsetHeight + 'px');
        headerMain.classList.add('is-stuck');
        document.body.classList.add('has-stuck-header');
      } else if (rect.top >= 0 && isStuck) {
        headerMain.classList.remove('is-stuck');
        document.body.classList.remove('has-stuck-header');
        document.body.style.removeProperty('--stuck-header-height');
      }
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  })();
})();